import {EntityAction, EntityCollectionServiceBase} from "@ngrx/data";
import {BehaviorSubject, combineLatest, Observable, Subscription} from "rxjs";
import {HttpModelConverter} from "../converter/httpModel.converter";
import {tap} from "rxjs/operators";
import {Injectable, OnDestroy} from "@angular/core";

@Injectable()
export abstract class EntityCollectionFindOneService<T, C extends HttpModelConverter<T>> implements OnDestroy {

    readonly loading$: Observable<boolean> = new BehaviorSubject(false);
    readonly error$: Observable<any> = new BehaviorSubject(undefined);
    readonly entity$: Observable<T> = new BehaviorSubject(null);
    readonly entityActions$: Observable<EntityAction>;
    protected id = undefined;
    protected value = undefined;
    protected readonly entityCollectionServiceBase: EntityCollectionServiceBase<T>;
    private rawEntity: T;
    readonly serviceName: string;
    readonly converter: C;
    private subscriptions: Subscription[] = [];

    protected constructor(serviceName: string, entityCollectionServiceBase: EntityCollectionServiceBase<T>, converter: C) {
        this.serviceName = serviceName + '-' + Math.random().toString(36).substr(2, 9);
        this.entityCollectionServiceBase = entityCollectionServiceBase;
        this.converter = converter;
        this.entityActions$ = entityCollectionServiceBase.entityActions$;

        this.subscriptions.push(combineLatest([
            this.loading$,
            this.entityCollectionServiceBase.entities$
        ]).pipe(
            tap(([loading, entities]) => {
                // // console.logByType['entityCollectionFindOneService', this.id, this.rawEntity, loading, entities]);
                if (loading === true || !this.id) {
                    (this.entity$ as BehaviorSubject<T>).next(null);
                } else {
                    const entity = entities.find(value => this.entityCollectionServiceBase.selectId(value) === this.id);
                    if (entity && this.rawEntity !== entity) {
                        this.rawEntity = entity;
                        (this.entity$ as BehaviorSubject<T>).next(this.converter.convert(entity));
                    }
                }
            })).subscribe());

        // TODO can be cleaver
        /* this.subscriptions.push(this.entityActions$.pipe(
            filter((entityAction) => entityAction.payload.entityOp === EntityOp.REMOVE_ALL
                || entityAction.payload.entityOp === EntityOp.REMOVE_ONE
                || entityAction.payload.entityOp === EntityOp.REMOVE_MANY
            ))
            .subscribe(() => {
                if (this.value) {
                    this.loadEntity(this.value)
                }
            })); */

    }

    public abstract loadEntity(value: any): Promise<T>;

    public isDtoSummary(): boolean {
        return false;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value?.unsubscribe());
    }


    protected setLoading(loading: boolean) {
        (this.loading$ as BehaviorSubject<boolean>).next(loading);
    }

    protected setError(error: any) {
        (this.error$ as BehaviorSubject<any>).next(error);
    }
}